module.exports = __webpack_public_path__ + "img/113.4.18078a8f.png";